import { PaymentMethodType } from '@features/invoicingSettings/enums/paymentMethodType'
import { IbanFields, PaymentMethod } from '@features/invoicingSettings/types/paymentMethod'

export const getDefaultIbanPaymentFields = (paymentMethods?: PaymentMethod[]): IbanFields | undefined => {
  const ibanMethod = paymentMethods?.find((paymentMethod) => paymentMethod.type === PaymentMethodType.IBAN)

  return ibanMethod?.fields as IbanFields
}
